export enum SubscriptionType {
  ANNUAL = "yearly",
  MONTHLY = "monthly",
}

export interface ILimit {
  can_remove_powered_by: boolean;
  filter_import: boolean;
  filter_rating: boolean;
  reviews_count: number;
  widget_colors: boolean;
  widget_review_button: boolean;
}

export enum InvoiceStatus {
  PAID = "paid",
  UNPAID = "unpaid",
  DRAFT = "draft",
  PENDING = "pending",
  SUCCESS = "succeeded",
  FAILED = "failed",
}

export interface SubscriptionHistory {
  period_start: string;
  period_end: string;
}

export interface Invoice {
  id: number;
  invoice_pdf: string;
  amount: number;
  status: string;
  subscription_history: SubscriptionHistory;
  created_at: string;
}

export interface IPlan {
  id?: string;
  interval?: string;
  status?: string;
  cost_per_month: number;
  old_cost_per_month?: number;
  created_at?: string;
  updated_at?: string;
  features: string[];
  limits?: ILimit;
  trial_days?: number;
  name: string;
  is_highlighted: boolean;
  months_off: number;
}

export interface IPaymentValues {
  name?: string;
  payment_method_id?: string;
  setup_intent?: string;
}

export enum Limits {
  CAN_REMOVE_POWERED_BY = "can_remove_powered_by",
  FILTER_IMPORT = "filter_import",
  FILTER_RATING = "filter_rating",
  REVIEWS_COUNT = "reviews_count",
  WIDGET_COLORS = "widget_colors",
  WIDGET_REVIEW_BUTTON = "widget_review_button",
  PAID_PLAN = "paid_plan",
}
export interface IProration {
  old_plan_proration: number;
  new_plan_proration: number;
  total: number;
}
